import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Input } from '@mui/material';
import endpoints from '@view/routes/endpoints';

export interface forgotPasswordModel {
  email: string;
}

interface ForgotPasswordFormProps {
  forgotPassword: (userCredential) => void;
  clearResetMessage: () => void;
  resetFailed: boolean;
  loading: boolean;
  // eslint-disable-next-line react/require-default-props
  resetMessage?: string;
}

const ForgotPassword: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<ForgotPasswordFormProps>>
> = ({
  forgotPassword,
  clearResetMessage,
  resetFailed,
  loading,
  resetMessage,
}: ForgotPasswordFormProps) => {
  // const {
  //   register,
  //   handleSubmit,
  //   trigger,
  //   formState: { errors },
  // } = useForm<forgotPasswordModel>({
  //   mode: 'onBlur',
  //   reValidateMode: 'onBlur',
  // });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [resetSucess, setResetSucess] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [message, setMessage] = useState<string | undefined>();
  const navigate = useNavigate();
  useEffect(() => {
    setResetSucess(resetFailed);
    return () => {
      setResetSucess(false);
    };
  }, [resetFailed]);

  useEffect(() => {
    setMessage(resetMessage);
  }, [resetMessage]);

  // useEffect(() => {
  //   let submitDisabled = false;
  //
  //   if (errors.email) {
  //     submitDisabled = true;
  //   }
  //
  //   setDisabled(submitDisabled || loading);
  // }, [errors.email, loading]);

  const onSubmit = (userData: forgotPasswordModel) => {
    forgotPassword(userData);
  };

  const onError = () => {
    // if (!errors.email) {
    //   setResetSucess(true);
    // }
  };

  const onChange = () => {
    // trigger('email');
  };

  const handleReturnToLogin = () => {
    clearResetMessage();
    navigate(endpoints.AUTH);
  };

  const renderForm = () => (
    <>
      <p className="text-center h1 leading-8 text-primary mb-3.5">
        Forgot your <br className="block sm:hidden " /> password?
      </p>
      <p className="mb-16 subtitle1 text-secondary">
        Insert the email you used to login.
      </p>
      <form
        // onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col items-center justify-center w-full"
      >
        <Input
          // type={InputTypes.email}
          name="email"
          // register={register}
          errorHandler={onError}
          onChange={onChange}
          required
          className="w-full mb-16 sm:w-1/2"
        />

        <LoadingButton
          disabled={disabled}
          loading={loading}
          className="w-64 mb-5 sm:mb-14 xl:mb-10 button"
          color="primary"
          variant="contained"
          type="submit"
        >
          Send Reset Link
        </LoadingButton>
      </form>
    </>
  );

  const renderMessage = () => (
    <div className="flex flex-col items-center justify-center">
      <p className="text-center h1 leading-8 text-primary mb-3.5">
        Password reset <br className="block sm:hidden " /> email sent
      </p>
      <p className="mb-16 text-center sm:text-left subtitle1 text-secondary w-80 md:w-full mu-1">
        {message}
      </p>
      <Button
        variant="contained"
        color="primary"
        className="w-64 mb-5 sm:mb-14 xl:mb-10 button"
        onClick={handleReturnToLogin}
      >
        Return To Login
      </Button>
    </div>
  );

  return renderForm();
  // return null;
};

ForgotPassword.defaultProps = {
  resetMessage: '',
};

export default ForgotPassword;
